'use strict';

require('./salary-distribution.scss');

module.exports = {
  template: require('./salary-distribution.html'),
  controller: require('./salary-distribution.controller'),
  controllerAs: 'vm',

  bindings: {
    round: '<',
    data: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-distribution/index.js
 ** module id = 237
 ** module chunks = 0
 **/